export class WebKitThemes {
    static SetTheme(theme, timeout = 8000) {
        let timer;
        return new Promise((resolve, reject) => {
            timer = setTimeout(() => {
                reject(null);
            }, timeout);
            try {
                window.nativeEvent.theme.themeSetAck = (themeAck) => {
                    clearTimeout(timer);
                    if (theme != themeAck)
                        reject();
                    else
                        resolve();
                };
                window.webkit.messageHandlers.theme.postMessage(theme);
            }
            catch (err) {
                reject(err);
            }
        });
    }
}
//# sourceMappingURL=Themes.js.map